/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <kpa@giap.pl>, February 2024
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import _ from 'lodash';

import AttachmentsPanel from '../../components/AttachmentsPanel';
import CustomizedMap from './CustomizedMap';
import { DecisionContainer } from '../../containers';
import EmptyFileDownloader from '../../components/EmptyFileDownloader/EmptyFileDownloader';
import { isMobileView, isTabletView, renderHelpDesc } from '../../components/utils/utils';
import fetch from '../../core/fetch/fetch.server';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import history from '../../core/history';
import loadingData from './loading';
import ModalAlert from './ModalAlert';
import { PersonalDataContainer } from '../../containers';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug/PowrotDoListyEuslug';
import { runService } from '../../actions/eservices';
import utils from './utils';
import v from './validators';

import pans from './panStyle.scss';


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const reasonOptions = [
  {
    label: 'wydzielenie działki/ek na powiększenie nieruchomości sąsiedniej (art. 93 ust. 2a ww. ustawy*)',
    value: 'powiekszenie',
    state: 'reason',
  },
  {
    label: 'wydzielenie działki/ek przeznaczonych pod drogę publiczną: gminną, powiatową, wojewódzką, krajową (art. 98 ust. 1 ustawy o gospodarce nieruchomościami*)',
    value: 'droga',
    state: 'reason',
  },
  {
    label: 'inne',
    value: 'inne',
    state: 'reason',
  },
];

const opinionTypeOptions = [
  {
    label: 'z ustaleniami planu miejscowego (art. 93 ust.1 ustawy o gospodarce nieruchomościami*)',
    value: 'plan_miejscowy',
    state: 'opinionType',
  },
  {
    label: 'z ustaleniami planu miejscowego – podział nieruchomości rolnej lub leśnej (art. 93 ust. 2a ustawy o gospodarce nieruchomościami*)',
    value: 'podzial_nieruchomosci',
    state: 'opinionType',
  },
  {
    label: 'braku sprzeczności z przepisami odrębnymi (art. 94 ust.1 pkt 1 ustawy o gospodarce nieruchomościami*)',
    value: 'brak_sprzecznosci',
    state: 'opinionType',
  },
  {
    label: 'z warunkami określonymi w decyzji Prezydenta Miasta o warunkach zabudowy i zagospodarowania terenu (art. 94 ust.1 pkt 2 ustawy o gospodarce nieruchomościami*)',
    value: 'warunki_decyzji',
    state: 'opinionType',
  },
  {
    label: 'inne',
    value: 'inne',
    state: 'opinionType',
  },
];

const roadAccessOptions = [
  {
    label: 'poprzez bezpośredni dostęp do ulic, drogi',
    value: 'bezposredni',
    state: 'roadAccess',
  },
  {
    label: 'poprzez drogę dojazdową',
    value: 'droga_dojazdowa',
    state: 'roadAccess',
  },
  {
    label: 'poprzez ustanowienie służebności drogowej (prawo przejazdu i przechodu)',
    value: 'sluzebnosc_drogowa',
    state: 'roadAccess',
  },
];

let InfoTypeDict = {
  registerNumber: {
    label: 'Numer księgi wieczystej:',
    editable: true,
    placeholder: 'Format numeru księgi: WL1A/00000123/1',
  },
  opinionType: {
    label: 'Wnoszę o wydanie opinii w sprawie zgodności proponowanego podziału nieruchomości:',
    editable: true,
    type: 'Select',
    options:  opinionTypeOptions,
  },
  reason: {
    label: 'Cel podziału nieruchomości:',
    editable: true,
    type: 'Select',
    options:  reasonOptions,
  },
  roadAccess: {
    label: 'Utworzone w wyniku podziału działki będą mieć zapewnioną obsługę komunikacyjną od strony drogi publicznej:',
    editable: true,
    type: 'Select',
    options:  roadAccessOptions,
  },
};


class OpiniaZgodnosciPodzialu extends React.Component {
  state = {
    info: {
      registerNumber: null,
      opinionType: null,
      opinionTypeSign: null,
      opinionTypeDate: null,
      opinionTypeOther: null,
      reason: null,
      reasonParcel: null,
      otherReason: null,
      roadAccess: null,
      roadAccessStreet: null,
      roadAccessParcel: null,
      roadAccessWidth: null,
      roadAccessWidthAndParcel: null,
    },
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    eserviceDistrict: null,
    selectedParcels: [],
    attachments: null,
    loading: false,
    isMounted: false,
  };

  validators = {
    registerNumber: [v.NotNull, v.CheckWieczysta],
    opinionType: [v.NotSelected],
    opinionTypeSign: [],
    opinionTypeDate: [],
    opinionTypeOther: [],
    reason: [v.NotSelected],
    reasonParcel: [],
    otherReason: [],
    roadAccess: [v.NotSelected],
    roadAccessStreet: [],
    roadAccessParcel: [],
    roadAccessWidth: [],
    roadAccessWidthAndParcel: [],
  };

  nextStep = '/eservices/eserviceSummary/';

  componentDidMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
        }, () => this.updateValidators());
      });

    this.setState({ isMounted: true });
  }

  updateValidators = () => {
    if (this.state.info.opinionType == 'warunki_decyzji') {
      this.validators.opinionTypeSign = [v.NotNull];
      this.validators.opinionTypeDate = [v.NotNull, v.CheckDate];
    } else if (this.state.info.opinionType == 'inne') {
      this.validators.opinionTypeOther = [v.NotNull];
      this.validators.opinionTypeSign = [];
      this.validators.opinionTypeDate = [];
    } else {
      this.validators.opinionTypeOther = [];
      this.validators.opinionTypeSign = [];
      this.validators.opinionTypeDate = [];
    }

    if (this.state.info.reason == 'powiekszenie') {
      this.validators.reasonParcel = [v.NotNull];
      this.validators.otherReason = [];
    } else if (this.state.info.reason == 'inne') {
      this.validators.reasonParcel = [];
      this.validators.otherReason = [v.NotNull];
    } else {
      this.validators.reasonParcel = [];
      this.validators.otherReason = [];
    }

    if (this.state.info.roadAccess == 'bezposredni') {
      this.validators.roadAccessStreet = [v.NotNull];
      this.validators.roadAccessParcel = [];
      this.validators.roadAccessWidth = [];
      this.validators.roadAccessWidthAndParcel = [];
    } else if (this.state.info.roadAccess == 'droga_dojazdowa') {
      this.validators.roadAccessStreet = [];
      this.validators.roadAccessParcel = [v.NotNull];
      this.validators.roadAccessWidth = [v.NotNull, v.isNumber];
      this.validators.roadAccessWidthAndParcel = [];
    } else if (this.state.info.roadAccess == 'sluzebnosc_drogowa') {
      this.validators.roadAccessStreet = [];
      this.validators.roadAccessParcel = [];
      this.validators.roadAccessWidth = [];
      this.validators.roadAccessWidthAndParcel = [v.NotNull];
    }
    else {
      this.validators.roadAccessStreet = [];
      this.validators.roadAccessParcel = [];
      this.validators.roadAccessWidth = [];
      this.validators.roadAccessWidthAndParcel = [];
    }

  }

  onHide = () => this.setState({ showError: false });

  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  onChangeSelect = (e, group) => {
    const name = e.state;
    if (name == 'opinionType') {
      const key1 = 'opinionTypeSign';
      const key2 = 'opinionTypeDate';
      const key3 = 'opinionTypeOther';

      const index = Object.keys(InfoTypeDict).indexOf('opinionType') + 1;
      if (e.value == 'warunki_decyzji') {
        const valueDict = {
          label: 'Znak decyzji:',
          editable: true,
        };
        const valueDict2 = {
          label: 'Data decyzji:',
          editable: true,
        };
        InfoTypeDict = utils.deleteKeys(InfoTypeDict, [key3]);
        InfoTypeDict = utils.insertKeyAtPosition(InfoTypeDict, key1, valueDict, index);
        InfoTypeDict = utils.insertKeyAtPosition(InfoTypeDict, key2, valueDict2, index + 1);
      } else if (e.value == 'inne') {
        const valueDict = {
          label: 'Inny rodzaj opinii:',
          editable: true,
        };
        InfoTypeDict = utils.deleteKeys(InfoTypeDict, [key1, key2]);
        InfoTypeDict = utils.insertKeyAtPosition(InfoTypeDict, key3, valueDict, index);
      }
      
      else {
        InfoTypeDict = utils.deleteKeys(InfoTypeDict, [key1, key2, key3]);
      }
    }

    if (name == 'reason') {
      const key1 = 'reasonParcel';
      const key2 = 'otherReason';

      const index = Object.keys(InfoTypeDict).indexOf('reason') + 1;
      if (e.value == 'powiekszenie') {
        const valueDict = {
          label: 'Nr działki sąsiedniej:',
          editable: true,
        };
        InfoTypeDict = utils.deleteKeys(InfoTypeDict, [key2]);
        InfoTypeDict = utils.insertKeyAtPosition(InfoTypeDict, key1, valueDict, index);
      } else if (e.value == 'inne') {
        const valueDict = {
          label: 'Inny cel podziału:',
          editable: true,
        };
        InfoTypeDict = utils.deleteKeys(InfoTypeDict, [key1]);
        InfoTypeDict = utils.insertKeyAtPosition(InfoTypeDict, key2, valueDict, index);
      }
      
      else {
        InfoTypeDict = utils.deleteKeys(InfoTypeDict, [key1, key2]);
      }
    }

    if (name == 'roadAccess') {
      const key1 = 'roadAccessStreet';
      const key2 = 'roadAccessParcel';
      const key3 = 'roadAccessWidth';
      const key4 = 'roadAccessWidthAndParcel';

      const index = Object.keys(InfoTypeDict).indexOf('roadAccess') + 1;
      if (e.value == 'bezposredni') {
        const valueDict = {
          label: 'Nazwa ulicy:',
          editable: true,
        };
        InfoTypeDict = utils.deleteKeys(InfoTypeDict, [key2, key3, key4]);
        InfoTypeDict = utils.insertKeyAtPosition(InfoTypeDict, key1, valueDict, index);
      } else if (e.value == 'droga_dojazdowa') {
        const valueDict = {
          label: 'Nr działki:',
          editable: true,
        };
        const valueDict2 = {
          label: 'Szerokość drogi [m]:',
          editable: true,
        };
        InfoTypeDict = utils.deleteKeys(InfoTypeDict, [key1, key4]);
        InfoTypeDict = utils.insertKeyAtPosition(InfoTypeDict, key2, valueDict, index);
        InfoTypeDict = utils.insertKeyAtPosition(InfoTypeDict, key3, valueDict2, index);
      }
      
      else {
        InfoTypeDict = utils.deleteKeys(InfoTypeDict, [key1, key2, key3]);
        const valueDict = {
          label: 'Szerokość służebności gruntowej oraz nr ewid. działki/ek przez jakie będzie ustanowiona służebność:',
          editable: true,
        };
        InfoTypeDict = utils.insertKeyAtPosition(InfoTypeDict, key4, valueDict, index);
      }
    }

    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.value,
        },
      },
      () => this.validate(group, name, this.updateValidators),
    );
  }

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['info'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  onChangeAttachments = (attachments, errorMessage) => {
    const errorText = errorMessage.errorText;
    const errorTitle = errorMessage.errorTitle;
    const showError = errorMessage.showError;
    this.setState({ attachments, errorText, errorTitle, showError });
  }

  validateAttachmentsContent = () => {
    if (this.state.attachments) {
      for (const attachment of this.state.attachments) {
        if (attachment.name.length < 1) return true;
      }
    }
    return false;
  }

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (this.state.selectedParcels.length === 0) {
      return this.setState({
        errorText: 'Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
        loading: false,
      });
    }

    if (hasFieldErrors) {
      return this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
        loading: false,
      });
    }

    if (!this.state.attachments || this.state.attachments.length === 0) {
      return this.setState({
        errorText: 'Wymagane jest dodanie załączników do składanego wniosku',
        errorTitle: 'Brak załączników.',
        showError: true,
        loading: false,
      });
    }

    const hasEmptyAttachment = this.validateAttachmentsContent();
    if (hasEmptyAttachment) {
      return this.setState({
        errorText: 'Przynajmniej jeden załącznik jest pusty. Dodaj plik do załączników',
        errorTitle: 'Pusty załącznik.',
        showError: true,
        loading: false,
      });
    }

    if (!hasFieldErrors && this.state.selectedParcels.length > 0) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          dzialki: this.state.selectedParcels,
          selectedParcels: this.state.selectedParcels,
          info: this.state.info,
          user: {
            ...this.props.serviceInfo.user,
          },
          shortName: this.props.serviceInfo.eservice.shortName,
          urzad: this.props.districts[this.props.prefix],
          attachments: this.state.attachments,
        })
        .then(resp => {
          this.setState({
            loading: false }, () =>
            this.redirectToSummary(resp.jobId));
        });
    }
  };

  redirectToSummary = (jobId) => {
    window.location.href = `${this.nextStep}${jobId}`;
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    const isMobile = this.state.isMounted && isMobileView(window);
    const isTablet = this.state.isMounted && isTabletView(window);
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user ? this.props.serviceInfo.user : null} />
        <GrayPanel
          title={'1. Adres'}
        >
          { renderHelpDesc(isMobile, isTablet) }
          <CustomizedMap
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
          />
        </GrayPanel>
        <DecisionContainer
          title={'2. Informacje'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={InfoTypeDict}
          onChange={e => this.onChange(e, 'info')}
          onChangeSelect={e => this.onChangeSelect(e, 'info')}
        />
        <GrayPanel title={'Informacje dodatkowe'} >
          
          <p><b>Do niniejszego wniosku należy dołączyć załączniki:</b></p>
          <p>1. Dokumenty stwierdzające tytuł prawny do nieruchomości w szczególności oświadczenie, o którym mowa w art. 116 ust. 2 pkt. 4 ww. ustawy</p>
          <p>2. Wypis z katastru nieruchomości i kopia mapy katastralnej obejmującej nieruchomość podlegającą podziałowi</p>
          <p>3. Decyzja o warunkach zabudowy i zagospodarowania terenu określającą zasady podziału nieruchomości (w przypadku braku planu miejscowego - podział z art. 94 ust. 1 pkt 2 ww. ustawy)</p>
          <p>4. Pozwolenie, wojewódzkiego konserwatora zabytków na podział, w przypadku nieruchomości wpisanej do rejestru zabytków</p>
          <p>5. Wstępny projekt podziału nieruchomości - 3 egz. (liczba egzemplarzy zwiększa się wraz liczbą wnioskodawców)</p>
          <p>6. Opinia biegłego zgodna z §4 ust. 1 i 2 Rozporządzenia Rady Ministrów z dnia 7 grudnia 2004 r. (Dz.U. nr 268 poz. 2663), jeżeli przedmiotem podziału jest nieruchomość zabudowana a proponowany podział powoduje także podział budynku</p>
          <p>7. Inne załączniki</p>

          <p>
            * - Ustawa z dnia 21 sierpnia 1997r. o gospodarce nieruchomościami (Dz.U. z 2023 r. poz. 344 ze zm.)
          </p>
        </GrayPanel>

        <AttachmentsPanel onChangeAttachments={this.onChangeAttachments} showExtraText={this.props.districts[this.props.prefix].attachmentsToEpuapEnabled}/>

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />

        <ModalAlert
          title={loadingData.loadingTitle}
          bodyText={loadingData.loadingBody}
          show={this.state.loading}
          name="loadingModal"
          onHide={this.onHide}
          disableButton
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ loading: true }, () => this.startService())}
            >
              Uruchom
            </button>
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

OpiniaZgodnosciPodzialu.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(OpiniaZgodnosciPodzialu),
);



// WEBPACK FOOTER //
// src/routes/eservices/OpiniaZgodnosciPodzialu.js